/* eslint-disable react/require-default-props */
import { ChangeEventHandler } from 'react';
import { FieldValues, Path, UnPackAsyncDefaultValues, UseFormRegister } from 'react-hook-form';
import { toString } from '../../utils/string';

interface Props<S extends FieldValues, T> {
  id?: string | undefined;
  name: Path<UnPackAsyncDefaultValues<S>>;
  allowEmpty: boolean;
  options: T[];
  register: UseFormRegister<S>;
  getValue: (x: T) => string | number | undefined;
  getLabel: (x: T) => string | number | undefined;
  isDisabled?: boolean;
  onChange?: ChangeEventHandler<HTMLSelectElement>;
  additionalClassName?: string | undefined;
  // setValue() など、ユーザーの操作以外で value が設定された場合、select の選択を同期させるための watch。getValues() でもいい？もしくは control を prop で受けてこのコンポーネントで useWatch() するか。
  watch?: ((names?: string | string[] | ((data: unknown, options: unknown) => void)) => unknown) | undefined;
}

/**
 * 一つだけ選択可能なドロップダウンを簡単に使えるようにしたコンポーネント
 * @param
 * @returns
 */
function SingleSelect<S extends FieldValues, T>({
  id = undefined,
  name,
  allowEmpty,
  options,
  register,
  getValue,
  getLabel,
  isDisabled = false,
  onChange = undefined,
  additionalClassName,
  watch,
}: Props<S, T>) {
  return (
    <span className={`dropdown ${toString(additionalClassName)}`}>
      <select
        id={id}
        {...register(name)}
        disabled={isDisabled}
        onChange={typeof onChange === 'function' ? onChange : register(name).onChange}
        value={typeof watch === 'function' ? toString(watch(name)) : undefined}
      >
        {allowEmpty && <option> </option>}
        {options.map((x) => (
          <option key={getValue(x)} value={getValue(x)}>
            {getLabel(x)}
          </option>
        ))}
      </select>
    </span>
  );
}

SingleSelect.defaultProps = {
  id: undefined,
  onChange: undefined,
  additionalClassName: undefined,
  watch: undefined,
};

export default SingleSelect;

export function transformSingleSelectValue(v: number | undefined) {
  return Number.isNaN(Number(v)) || Number(v) === 0 ? undefined : Number(v);
}
